// Copyright (c) 2016 Deere & Company

import SettlementNoRegistration from '../../../reports/settlement-no-registration/state-connector';

export default {
    component: SettlementNoRegistration,
    name: 'SETTLEMENT_NO_REGISTRATION',
    path: 'settlement-no-registration'
};



// WEBPACK FOOTER //
// ./src/routes/products/reports/settlement-no-registration.js